import CookieCheckbox from './Checkbox'

export default class CookieOptionsView {

    constructor(element, button, CookieBar) {
        this.element = element
        this.openButton = button
        this.CookieBar = CookieBar

        this.open = false

        const options = [...this.element.querySelectorAll('div.checkbox')]
        for (let i = 0; i < options.length; i++) {
            new CookieCheckbox(options[i], this.Cookiebar, this.CookieBar.onChange)
        }

        this.onResize = this.onResize.bind(this)
        this.onResize()
        window.addEventListener('resize', this.onResize)
        this.openButton.addEventListener('click', this.onOpen.bind(this))
    }

    onResize() {
        this.CookieBar.element.style.height = '' // reset to og height.

        this.advancedHeight = this.element.offsetHeight + 20
        this.originalHeight = this.CookieBar.element.offsetHeight

        const subtract = this.open ? 0 : this.advancedHeight // 'close' when the this.open = false.
        this.CookieBar.element.style.height = `${this.originalHeight - subtract}px`
    }

    onOpen() {
        this.open = !this.open
        const offset = this.CookieBar.element.offsetHeight

        this.openButton.classList[this.open ? 'add' : 'remove']('active')
        this.CookieBar.element.style.height = `${!this.open ? (offset - this.advancedHeight) : (offset + this.advancedHeight)}px`
    }
}